import React from 'react'
import { Image, Typography } from 'antd'
import cn from 'classnames'

import VerifiedBadge from 'assets/images/verified-badge.svg?react'
import styles from './whatsapp-preview.module.scss'

const { Text } = Typography

const WhatsAppPreview = ({
  isMass,
  children,
  name = 'Kledo',
  subtitle = 'Official Business Account',
  showVerified = true,
  avatar,
}) => {
  return (
    <div className={cn(styles.previewSection, isMass && styles.previewSectionMass)}>
      <div className={styles.previewCard}>
        <div className={styles.whatsappPreview}>
          {/* WhatsApp Header */}
          <div className={styles.whatsappHeader}>
            <div className={styles.whatsappAvatar}>
              {avatar ?? (
                <Image
                  src="/resources/images/logo-color-kledo-front.png"
                  alt="Kledo"
                  preview={false}
                  width={25}
                />
              )}
            </div>
            <div className={styles.whatsappProfileText}>
              <div className={styles.whatsappName}>
                <Text className={styles.whatsappNameText}>{name}</Text>
                {showVerified && <VerifiedBadge style={{ marginLeft: 4 }} />}
              </div>
              <Text className={styles.whatsappBusinessText}>{subtitle}</Text>
            </div>
          </div>

          {/* WhatsApp Message */}
          <div className={cn(styles.whatsappBody, isMass && styles.whatsappBodyMass)}>
            <div className={styles.whatsappMessage}>
              <span>{children}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WhatsAppPreview
